/*
 * @Descripttion:
 * @Author: Junteng Shi
 * @Date: 2025-03-06 14:58:24
 * @LastEditors: HongJian Liu
 * @LastEditTime: 2025-06-11 14:36:24
 */
import App from './App.vue';
import router from './router';
import piniaStore from './store';
import permission from './utils/permission';
import checkPer from './utils/checkPer';

import '@/styles/normalize.min.css';
import '@/styles/index.less';
// import '@/styles/element/index.css';
import '@/styles/element/2130c8.css';

// 支持SVG
import 'virtual:svg-icons-register';
import '@arco-design/web-vue/dist/arco.css';

import 'virtual:uno.css';

// import 'element-plus/theme-chalk/dark/css-vars.css'

//vue3的挂载方式
const app = createApp(App);

app.use(router);
app.use(piniaStore);
app.use(permission);
app.use(checkPer);
app.mount('#app');
